export default __webpack_public_path__ + "static/media/SEN-POW-OWON-OLD.286a3ebb.png";